<ng-container *transloco="let _t">

<h5><mat-icon>description</mat-icon> Notes 
	<small>({{action.jsonDetails.comments.length}})</small></h5>

<ul class="comment-list" *ngIf="showComments">
	<li *ngFor="let comm of action.jsonDetails.comments; let i=index" [id]="'comm'+i">

		<button mat-icon-button *ngIf="!comm.edit" (click)="comm.confirming=true" class="delBtn">
			<mat-icon>remove_circle_outline</mat-icon>
		</button>

		<div class="confirming" *ngIf="comm.confirming" >
			Supprimer cette note ?<br>
			<button mat-raised-button  color="disabled"
			(click)="deleteComment(comm, i)">
				{{ _t('Confirmer') }}
			</button> &nbsp;
			<button mat-raised-button color="warn" (click)="comm.confirming=false">
				{{ _t('Annuler') }}
			</button>
		</div>
		
		<p class="note" *ngIf="!comm.edit">
			<span (dblclick)="focusComment(comm, i)" 
			[title]="_t('mdr-comments-title-0')">
				{{comm.note}}
			</span>
		</p>
		<textarea *ngIf="comm.edit" 
				class="input" 
				[placeholder]="_t('mdr-comments-placeholder-0')"
				[(ngModel)]="comm.note" 
				[focusMe]="true"
				(blur)="blurComment(comm, i)"
				(keydown)="blurComment(comm, i, $event)">
		</textarea>
		<p class="info">
			Le {{comm.date | date:'short':undefined:'fr-FR'}} 
			<span *ngIf="comm.user">
			par {{comm.user.name}}
			</span>
		</p>
	</li>
	<li>
		<button mat-flat-button color="basic"
				(click)="addComment()">
			<mat-icon>note_add</mat-icon> 
			{{ _t('add-note') }}
		</button>
	</li>
</ul>

</ng-container>